import * as React from 'react';

import { CollapsedList } from '../../components/CollapsedList';

export interface ICollapsedListContainerProps<TItem> {
  list: TItem[];
  collapsedLength: number;
  expandCount?: number;
  renderItem: (item: TItem, index: number) => React.ReactNode;
  renderList: (children: React.ReactNode) => React.ReactNode;
  onExpand?(): void;
}

export function CollapsedListContainer<TItem>({
  list,
  collapsedLength,
  expandCount,
  renderItem,
  renderList,
  onExpand,
}: ICollapsedListContainerProps<TItem>) {
  const [visibleListLength, setVisibleListLength] = React.useState(collapsedLength);

  const handleOnExpand = React.useCallback(() => {
    const newLength = expandCount ? visibleListLength + expandCount : list.length;
    setVisibleListLength(newLength);

    if (onExpand) {
      onExpand();
    }
  }, [list.length, visibleListLength, setVisibleListLength, expandCount, onExpand]);

  const expandable = React.useMemo(() => {
    return list.length > visibleListLength;
  }, [list.length, visibleListLength]);

  const visibleList = React.useMemo(() => {
    const renderedList = list.slice(0, visibleListLength).map((item, index) => renderItem(item, index));

    return renderList(renderedList);
  }, [list, visibleListLength, renderItem, renderList]);

  return <CollapsedList list={visibleList} expandable={expandable} onExpand={handleOnExpand} />;
}
